/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：377__part-0
 */

"use strict"

import { u, d, p } from "./index__part-1"
import { m } from "./index__part-2"
var r = {}
Object.defineProperty(r, "getCurrentScreenWorkspaceData", {
  get: function () {
    return u
  }
})
Object.defineProperty(r, "applyIdeToOp", {
  get: function () {
    return d
  }
})
Object.defineProperty(r, "addWorkspace", {
  get: function () {
    return p
  }
})
var o = {}
Object.defineProperty(o, "applyServerOp", {
  get: function () {
    return m
  }
})
export { r }
export { o }
